// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us-dialog {
  min-width: 600px;
  border-radius: 16px;
  background: var(--surface-1);
  padding: 32px;
  box-sizing: border-box;
  position: relative;
}

.contact-us-dialog__textarea {
  width: 100%;
  min-height: 200px;
  border: 1px solid var(--border-strong);
  border-radius: 4px;
  padding: 12px;
  font-size: 16px;
  margin-bottom: 32px;
  resize: none;
  box-sizing: border-box;
  background-color: var(--surface-2);
  color: var(--text-primary);
}

.contact-us-dialog__textarea:focus {
  outline: none;
  border-color: var(--accent);
}

.contact-us-dialog__helper-text {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 16px;
  font-style: italic;
} `, "",{"version":3,"sources":["webpack://./src/dialogs/ContactUsDialog.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".contact-us-dialog {\n  min-width: 600px;\n  border-radius: 16px;\n  background: var(--surface-1);\n  padding: 32px;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.contact-us-dialog__textarea {\n  width: 100%;\n  min-height: 200px;\n  border: 1px solid var(--border-strong);\n  border-radius: 4px;\n  padding: 12px;\n  font-size: 16px;\n  margin-bottom: 32px;\n  resize: none;\n  box-sizing: border-box;\n  background-color: var(--surface-2);\n  color: var(--text-primary);\n}\n\n.contact-us-dialog__textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n.contact-us-dialog__helper-text {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n  font-style: italic;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
